module.exports = __webpack_public_path__ + "img/dd-logo-ford-25.ff493cc8.png";